module.exports = __webpack_public_path__ + "img/head.0d45eb3f.jpg";